import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetWidgetCustomFields as GetWidgetCustomFieldsQuery,
    GetWidgetCustomFields_widgetCustomFields as WidgetCustomFields,
    GetWidgetCustomFieldsVariables,
} from 'nutshell-graphql-types';

import GET_WIDGET_CUSTOM_FIELDS from '../queries/get-widget-custom-fields.graphql';

export const useGetWidgetCustomFields = (
    entityId: string,
    widgetId: string
): {
    customFields: WidgetCustomFields | null | undefined;
    isLoading: boolean;
    isFirstLoad: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, networkStatus, data, error, refetch} = useQuery<
        GetWidgetCustomFieldsQuery,
        GetWidgetCustomFieldsVariables
    >(GET_WIDGET_CUSTOM_FIELDS, {
        variables: {
            entityId,
            widgetId,
        },
        fetchPolicy: 'cache-and-network',
    });

    return {
        customFields: data && data.widgetCustomFields,
        isLoading: loading,
        isFirstLoad: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
